import { observer } from 'mobx-react';

import { useConfigureCandidateManagementIntercom } from 'src/utils/hooks/useCandidateManagementIntercomTour';

export const IntercomConfiguration = observer(() => {
  useConfigureCandidateManagementIntercom();
  return null;
});
